import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Nav from "../../component/nav/nav";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import Bot from "../../component/bot";
import Beard from "../../component/bread/breadcrumb";

const list = [{ name: "$singlee_nw1", path: "/news/center" }, { name: "$singlee_nw3", path: "/news/paper" }];

function Index() {
  const { t } = useTranslation();
  const location = useLocation();

  const [mobile, setMobile] = useState(window.innerWidth < 1025);
  const navigate = useNavigate();


  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setMobile(window.innerWidth < 1025);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <div style={{ height: "100%" }}>
      <Nav
        styles={{ position: "fixed", left: "0", top: "0", zIndex: "10" }}
      ></Nav>
      <div style={{ overflowX: "hidden" }}>
        <div className={css.topbg}>
          <div className={css.title}>{t("新闻中心")}</div>
          <div className={css.content}>{t("$singlee_nw2")}</div>
        </div>
        <div className={`${mobile ? css.flexzoneMobile : css.flexzone}`}>
          <div className={css.left}>
            {list.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${css.item} ${location.pathname === item.path ? css.activeFont : ""
                    }`}
                  onClick={() => {
                    navigate(item.path, { replace: true });
                  }}
                >
                  {t(item.name)}
                </div>
              );
            })}
          </div>
          {mobile ? (
            <></>
          ) : (
            <div className={css.right}>
              <Beard />
            </div>
          )}
        </div>
        <Outlet />
      </div>

      <Bot></Bot>
    </div>
  );
}

export default React.memo(Index);
